import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorData } from 'src/app/common/models/ErrorData';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';

@Component({
    selector: 'error-popup',
    templateUrl: './errorpopup.component.html',
    styleUrls: ['./errorpopup.component.scss'],
    standalone: false
})
export class ErrorpopupComponent implements OnInit {
  @Input() errorDataObj: ErrorData = new ErrorData();
  errorCode: string = '';
  hideInFtWeb: boolean = true; //This error mesage will not show in angular 9 app due to this configuration. This angular 9 app pass the error to parent website.

  constructor(public activeModal: NgbActiveModal, private parentCommunicator: ParentCommunicatorService) {
    // add publisher at globalErrorHandler to get subscribed data when use this component
    // this.parentCommunicator.Subscribe("ErrorOccured", (errCode) => {
    //   this.errorDataObj.IsError = errCode.length > 0 ? true : false;
    // });
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.errorDataObj.ErrorResponse.ResponseStatus)
      this.errorCode = this.errorDataObj.ErrorResponse.ResponseStatus + ' : ';
  }

  closeErrPopup() {
    console.log("errorDataObj", this.errorDataObj);
    this.errorDataObj.IsError = false;
    // Navigation after close or action after close need to be added
  }
}
